/** ************************************************************************
DEVELOPMENT ENVIRONMENT
************************************************************************** */

import { ExtensionApiStrategy } from '~cdw-ae/common/frontend/browser-extension-api';

export enum RuntimeEnvironment {
  LOCAL = 'local',
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
}
export const environment = {
  showDebug: true,
  environment: RuntimeEnvironment.DEVELOPMENT,
  apiServer: 'https://gopher-buddy-dev.appspot.com',
  apiToken: 'dsalj009mnv-8sdjhsa8jhd',
  production: false,
  extensionApiStrategy: ExtensionApiStrategy.CHROME,
  defaultTimings: {
    idleDetectionIntervalInSeconds: 300, // How many seconds of inactivity before  user is considered inactive
    networkStatusCheckIntervalInSeconds: 120, // check for online/offline status every 2 minutes
    checkInIntervalInSeconds: 1800, // How long before the extension checks in with the API
    userSessionCheckinRateInSeconds: 60, // How often the extension sends user session pings to pubsub
    userSessionCreateRateInSeconds: 30, // How often the extension creates a new user session. I figure 2x a idle detection interval is good
  },
  pubsubConfig: {
    topic: 'session-ingest',
    project: 'gopher-buddy-dev',
    apiKey: 'AIzaSyDohjOA7iUvcThHmJI7Ulq-it-z-fdytxc',
    attributes: ['userId', 'deviceId', 'timestamp'],
  },
  publicUrls: {
    faqHelp:
      'https://amplifiedlabs.zendesk.com/hc/en-us/articles/360051865934-Frequently-Asked-Gopher-Buddy-Questions-for-End-Users',
  },
  // Values used when running the extension in local mode
  localApiOverrides: {
    osVersion: '',
  },
};
